import styled, { css } from 'styled-components';

import { getThemeColor, getThemePath, getThemeTransition } from '@utils/styled';

import { BUTTON_VARIANTS, StyledLabel } from '@common/components/Button';
import { IconButton } from '@common/components/IconButton';
import Typography from '@common/components/Typography';

export const Container = styled.div``;

export const AddFileButton = styled(StyledLabel).attrs({
  variant: BUTTON_VARIANTS.LEVEL_1_GREEN_SMALL,
})`
  display: inline-flex;
  justify-content: center;
`;

export const FileInput = styled.input`
  display: none;
`;

export const FilesList = styled.div`
  overflow: hidden;
  ${({ theme, $hasFiles }) =>
    $hasFiles && theme.getFluidSpacing('margin-bottom', 'equal', 7)}
`;

export const DeleteButton = styled(IconButton)`
  box-shadow: none;
  background-color: ${getThemeColor('bluegrey.92')};

  &:hover,
  &:focus {
    background-color: ${getThemeColor('bluegrey.92')};
  }

  > svg {
    width: 1.7rem;
    height: 1.7rem;
    fill: ${getThemeColor('bluegrey.60')};
  }
`;

export const RemoveInvalidButton = styled(IconButton)`
  width: 3.2rem;
  height: 3.2rem;
  box-shadow: none;
  background-color: ${getThemeColor('bluegrey.92')};

  &:hover,
  &:focus {
    background-color: ${getThemeColor('bluegrey.92')};
  }

  > svg {
    width: 1.4rem;
    height: 1.4rem;
    fill: ${getThemeColor('bluegrey.60')};
  }
`;

export const ValidItem = styled.div`
  overflow: visible;
  opacity: 1;
  display: flex;
  align-items: center;
  height: 7rem;
  border-bottom: 1px solid ${getThemeColor('bluegrey.90')};
  transition:
    height 0.3s ease,
    opacity 0.25s ease;

  &:first-child {
    border-top: 1px solid ${getThemeColor('bluegrey.90')};
  }
`;

export const InvalidItems = styled.div`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 3)}
`;

export const InValidItem = styled.div`
  overflow: visible;
  opacity: 1;
  display: flex;
  align-items: center;
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'equal', 5)}
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'equal', 5)}
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'equal', 5)}
  ${({ theme }) => theme.getFluidSpacing('padding-right', 'equal', 4)}
  ${({ theme }) => theme.getFluidSpacing('padding-left', 'equal', 4)}
  border: 1px solid ${getThemeColor('hue.red')};
  border-radius: ${getThemePath(['borderRadiuses', 'normal.2'])}rem;
  background-color: ${getThemeColor('bluegrey.97')};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ValidFileName = styled(Typography).attrs({
  customAs: 'span',
  variant: 'paragraph1',
  maxLines: 1,
})`
  overflow: hidden;
  max-width: 100%;
  margin: 0;
  ${({ theme }) => theme.getFluidSpacing('margin-right', 'equal', 4)}
  color: ${({ $loading, theme }) => {
    if ($loading) {
      return getThemeColor('bluegrey.70')({ theme });
    }

    return 'inherit';
  }};
  text-overflow: ellipsis;
  transition: ${getThemeTransition('color')};
`;

export const InvalidFileName = styled(Typography).attrs({
  customAs: 'span',
  variant: 'body2',
})`
  max-width: 100%;
  margin: 0;
  ${({ theme }) => theme.getFluidSpacing('margin-right', 'equal', 4)}
  color: ${({ theme }) => getThemeColor('hue.red')({ theme })};
  transition: ${getThemeTransition('color')};
`;

export const InvalidFileNameText = styled.span`
  font-weight: bold;
`;

export const StatusColumn = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const StatusIcon = styled.div`
  ${({ theme }) => theme.getFluidSpacing('margin-right', 'equal', 4)}
`;

const iconStyles = css`
  width: 1.6rem;
  height: 1.6rem;
  border-radius: ${getThemePath(['borderRadiuses', 'circle'])};

  > svg {
    display: block;
    fill: ${getThemeColor('grey.100')};
  }
`;

export const ValidIcon = styled.div`
  ${iconStyles};
  padding-top: 0.5rem;
  padding-left: 0.4rem;
  background-color: ${getThemeColor('hue.green')};

  > svg {
    width: 0.9rem;
    height: 0.7rem;
  }
`;
